export default function Qa() {
    return <div>Qa</div>;
}
